import { Link } from "react-router-dom";

export const HajiKhususTeaser = () => {
  return (
<section
  id="haji-khusus"
className="scroll-mt-32 py-10 lg:min-h-screen lg:flex lg:items-center bg-[color:var(--bg)]"
>
      <div className="max-w-6xl mx-auto px-6">

        <div className="text-center mb-8">
          <span className="text-primary font-medium">
            Program Haji Khusus
          </span>

          <h2 className="mt-2 text-3xl md:text-4xl font-bold text-main">
            Haji Khusus Bersama Baba Tour
          </h2>

          <p className="mt-4 text-muted max-w-2xl mx-auto">
            Program haji khusus dengan pelayanan premium,
            pendampingan profesional, dan kenyamanan yang
            dirancang untuk membantu jamaah beribadah dengan lebih tenang.
          </p>
        </div>

        <div className="rounded-3xl overflow-hidden shadow-lg">
<img
  src="/images/haji-khusus-flyer.jpg"
  alt="Haji Khusus Baba Tour"
  className="w-full lg:max-h-[500px] object-contain"
 />
        </div>

<div className="text-center mt-4 lg:mt-2">
          <Link
            to="/haji-khusus"
            className="inline-flex items-center px-8 py-4 rounded-full bg-primary text-white hover:opacity-90 transition"
          >
            Pelajari Selengkapnya
          </Link>
        </div>

      </div>
    </section>
  );
};
